import { render, staticRenderFns } from "./NewAgentLink.vue?vue&type=template&id=a40cfd04&scoped=true"
import script from "./NewAgentLink.vue?vue&type=script&lang=js"
export * from "./NewAgentLink.vue?vue&type=script&lang=js"
import style0 from "./NewAgentLink.vue?vue&type=style&index=0&id=a40cfd04&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a40cfd04",
  null
  
)

export default component.exports